import { State } from '@server/states/State'
import { GameConfigDto } from '@server/types/dto'
import { Room } from 'colyseus.js'
import { StageVideo } from '../components/StageVideo'
import { audioContext } from '../phaser.config'

export class BaseScene extends Phaser.Scene {
	public room: Room<State>

	constructor(key: string, options?: Phaser.Types.Scenes.SettingsConfig) {
		super({ key, ...options })
	}

	preload() {
		this.load.setBaseURL('')
		this.room = (this.sys.settings.data as any).room

		for (const file of (this.sys.settings.data as GameConfigDto).audio) {
			this.load.audio(file.key, file.filepath)
		}

		this.load.font('Rubik', '.proxy/assets/font/Rubik-VariableFont_wght.ttf')

		// this.load.setBaseURL('assets')
		this.load.video('we_jam_bass', '.proxy/assets/video/we_jam_bass.webm', true)
		this.load.video('we_jam_synth', '.proxy/assets/video/we_jam_synth.webm', true)
		this.load.video('we_jam_drums', '.proxy/assets/video/we_jam_drums.webm', true)
		this.load.video('we_jam_perc', '.proxy/assets/video/we_jam_perc.webm', true)
		this.load.video('we_jam_keys', '.proxy/assets/video/we_jam_keys.webm', true)

		this.load.video('we_jam_perform', '.proxy/assets/video/we_jam_perform.webm', true)
		this.load.video('we_jam_lobby', '.proxy/assets/video/we_jam_lobby.webm', true)

		this.load.image('spark', '.proxy/assets/img/spark.png')
		this.load.image('musicnote', '.proxy/assets/img/musicnote.png')

		this.load.image('card_back', '.proxy/assets/img/cards/Back.png')
		this.load.image('card_drums', '.proxy/assets/img/cards/Drums.png')
		this.load.image('card_synth', '.proxy/assets/img/cards/Synth.png')
		this.load.image('card_bass', '.proxy/assets/img/cards/Bass.png')
		this.load.image('card_keys', '.proxy/assets/img/cards/Keys.png')
		this.load.image('card_perc', '.proxy/assets/img/cards/Perc.png')

		this.load.image('ProfileFrame01_Border', '.proxy/assets/img/ui/ProfileFrame01_Border.png')
		this.load.image('DefaultAvatar', '.proxy/assets/img/ui/Default_Avatar.png')
		this.load.image('Button01_Purple', '.proxy/assets/img/ui/Button01_Purple.png')
		this.load.image('ArrowLeft', '.proxy/assets/img/ui/ArrowLeft.png')
		this.load.image('ArrowRight', '.proxy/assets/img/ui/ArrowRight.png')
		this.load.image('Title_Flag02_Orange', '.proxy/assets/img/ui/Title_Flag02_Orange.png')
		this.load.image('Title_Flag02_Purple', '.proxy/assets/img/ui/Title_Flag02_Purple.png')
		this.load.image('Icon_PictoIcon_Setting', '.proxy/assets/img/ui/Icon_PictoIcon_Setting.png')
		this.load.image('BannerFrame03_Single_Navy', '.proxy/assets/img/ui/BannerFrame03_Single_Navy.png')
		this.load.image('Icon_PictoIcon_Lock_l', '.proxy/assets/img/ui/Icon_PictoIcon_Lock_l.png')
		this.load.image('Icon_Dice_Yellow', '.proxy/assets/img/ui/Icon_Dice_Yellow.png')
		this.load.image('Pictoicon_Dice', '.proxy/assets/img/ui/Pictoicon_Dice.png')
		this.load.image('Icon_Dice', '.proxy/assets/img/ui/Icon_Dice.png')
		this.load.image('Slider_Icon01_icon2', '.proxy/assets/img/ui/Slider_Icon01_icon2.png')
		this.load.image('BorderFrame_Circle81', '.proxy/assets/img/ui/BorderFrame_Circle81.png')
		this.load.image('Icon_PictoIcon_Exit_l', '.proxy/assets/img/ui/Icon_PictoIcon_Exit_l.png')
		this.load.image('Pictoicon_Viking_Helmet', '.proxy/assets/img/ui/Pictoicon_Viking_Helmet.png')
		this.load.image('Icon_PictoIcon_Sound_on', '.proxy/assets/img/ui/Icon_PictoIcon_Sound_on.png')
		this.load.image('Pictoicon_Share', '.proxy/assets/img/ui/Pictoicon_Share.png')
		this.load.image('Pictoicon_Friend_Add', '.proxy/assets/img/ui/Pictoicon_Friend_Add.png')
		this.load.image('CardFrame06_Bg_Yellow', '.proxy/assets/img/ui/CardFrame06_Bg_Yellow.png')

		this.load.image('Icon_Megaphone', '.proxy/assets/img/ui/Icon_Megaphone.png')
		this.load.image('Icon_Quest', '.proxy/assets/img/ui/Icon_Quest.png')
		this.load.image('Icon_Trophy', '.proxy/assets/img/ui/Icon_Trophy.png')

		this.load.image('Icon_Crown', '.proxy/assets/img/ui/Icon_Crown.png')
		this.load.image('soundboard_idle', '.proxy/assets/img/ui/soundboard_idle.png')
		this.load.image('soundboard_down', '.proxy/assets/img/ui/soundboard_down.png')
		this.load.image('Title_Ribbon_Bg_Yellow', '.proxy/assets/img/ui/Title_Ribbon_Bg_Yellow.png')
		this.load.image('Icon_PictoIcon_Close', '.proxy/assets/img/ui/Icon_PictoIcon_Close.png')
		this.load.image('Slider_Icon01_icon2', '.proxy/assets/img/ui/Slider_Icon01_icon2.png')
		this.load.image(
			'Slider_BasicTriple_Fill_Middle_Yellow',
			'.proxy/assets/img/ui/Slider_BasicTriple_Fill_Middle_Yellow.png'
		)
		this.load.image('Button01_Yellow', '.proxy/assets/img/ui/Button01_Yellow.png')
		this.load.image('ItemFrame01_Single_Purple', '.proxy/assets/img/ui/ItemFrame01_Single_Purple.png')
		this.load.image('Title_Flag01_Purple', '.proxy/assets/img/ui/Title_Flag01_Purple.png')
		this.load.image('2024_WeJam_Icon_Cup', '.proxy/assets/img/ui/2024_WeJam_Icon_Cup.png')
		this.load.image('Icon_PictoIcon_Resume', '.proxy/assets/img/ui/Icon_PictoIcon_Resume.png')

		this.load.image('StageFrame_s', '.proxy/assets/img/ui/StageFrame_s.png')
		this.load.image('StageFrame_n_Yellow', '.proxy/assets/img/ui/StageFrame_n_Yellow.png')

		this.load.image('logo_transparent', '.proxy/assets/img/logo.png')

		this.load.image('bass', '.proxy/assets/img/icons/Icon_Bass_Black.png')
		this.load.image('drums', '.proxy/assets/img/icons/Icon_Drums_Black.png')
		this.load.image('keys', '.proxy/assets/img/icons/Icon_Keys_Black.png')
		this.load.image('perc', '.proxy/assets/img/icons/Icon_Perc_Black.png')
		this.load.image('synth', '.proxy/assets/img/icons/Icon_Synth_Black.png')

		this.load.image('bass_white', '.proxy/assets/img/icons/Icon_Bass_White.png')
		this.load.image('drums_white', '.proxy/assets/img/icons/Icon_Drums_White.png')
		this.load.image('keys_white', '.proxy/assets/img/icons/Icon_Keys_White.png')
		this.load.image('perc_white', '.proxy/assets/img/icons/Icon_Perc_White.png')
		this.load.image('synth_white', '.proxy/assets/img/icons/Icon_Synth_White.png')

		this.load.image('Button03_Purple', '.proxy/assets/img/ui/Button03_Purple.png')
		this.load.image('Button03_Yellow', '.proxy/assets/img/ui/Button03_Yellow.png')
	}

	create() {
		this.addBackgroundVideo()
		this.addAudioContextResumeForce()

		this.hideLoadingSplash()
	}

	hideLoadingSplash() {
		document.getElementById('loading')?.remove()
	}

	addAudioContextResumeForce() {
		audioContext.onstatechange = () => {
			if (audioContext.state === 'suspended') {
				audioContext.resume()
			}
		}
	}

	addBackgroundVideo() {
		new StageVideo(this, 'background_video', 'we_jam_lobby')
	}
}
